// 常见复姓：中文姓名以复姓开头时头像显示两个字。
const COMPOUND_SURNAMES = new Set([
  '欧阳',
  '太史',
  '端木',
  '上官',
  '司马',
  '东方',
  '独孤',
  '南宫',
  '万俟',
  '闻人',
  '夏侯',
  '诸葛',
  '尉迟',
  '公羊',
  '赫连',
  '澹台',
  '皇甫',
  '宗政',
  '濮阳',
  '公冶',
  '太叔',
  '申屠',
  '公孙',
  '慕容',
  '仲孙',
  '钟离',
  '长孙',
  '宇文',
  '司徒',
  '鲜于',
  '司空',
  '闾丘',
  '子车',
  '亓官',
  '司寇',
  '巫马',
  '公西',
  '颛孙',
  '壤驷',
  '公良',
  '漆雕',
  '乐正',
  '宰父',
  '谷梁',
  '拓跋',
  '夹谷',
  '轩辕',
  '令狐',
  '段干',
  '百里',
  '呼延',
  '东郭',
  '南门',
  '羊舌',
  '微生',
  '公户',
  '公玉',
  '公仪',
  '梁丘',
  '公仲',
  '公上',
  '公门',
  '公山',
  '公坚',
  '左丘',
  '公伯',
  '西门',
  '公祖',
  '第五',
  '公乘',
  '贯丘',
  '公皙',
  '南荣',
  '东里',
  '东宫',
  '仲长',
  '子书',
  '子桑',
  '即墨',
  '达奚',
  '褚师',
]);

const HAN = /\p{Script=Han}/u;

/** 无照片头像文字：中文取姓（复姓两字），其他取首尾单词首字母。 */
export function avatarInitials(fullName: string | null | undefined): string {
  const name = fullName?.trim() ?? '';
  if (!name) return 'U';
  if (HAN.test(name[0] ?? '')) {
    const compact = name.replace(/\s+/g, '');
    const firstTwo = compact.slice(0, 2);
    return compact.length > 2 && COMPOUND_SURNAMES.has(firstTwo) ? firstTwo : compact.slice(0, 1);
  }
  const words = name.split(/\s+/).filter(Boolean);
  const first = Array.from(words[0] ?? '')[0] ?? '';
  const last = words.length > 1 ? (Array.from(words[words.length - 1] ?? '')[0] ?? '') : '';
  return `${first}${last}`.toUpperCase() || 'U';
}
